export const VALIDATION_ACCEPTED = {
  all: ['VALIDATED', 'TO_BE_VALIDATED', 'REFUSED'],
};
